module.exports = __webpack_public_path__ + "img/asus-fnac.9ceddbf5.jpg";